import { render, staticRenderFns } from "./RegionsEditPage.vue?vue&type=template&id=2e88a381&"
import script from "./RegionsEditPage.vue?vue&type=script&lang=js&"
export * from "./RegionsEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports